const autoNgTemplateLoaderTemplate1 = require('./dashboardClusterAgentInfo.html');

angular.module('shbdeployer.docker').component('dashboardClusterAgentInfo', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'DashboardClusterAgentInfoController',
});
